<template>
  <v-container fluid>
    <v-btn text class="mb-4" @click="$router.back()">
      <v-icon left>mdi-arrow-left</v-icon>
      Back to gallery
    </v-btn>

    <v-row>
      <!-- Image -->
      <v-col cols="12" md="7">
        <v-card outlined>
          <v-img
            :src="submission?.imageUrl"
            aspect-ratio="1.6"
            class="rounded"
          />
        </v-card>
      </v-col>

      <!-- Details -->
      <v-col cols="12" md="5">
        <v-card outlined>
          <v-card-title class="font-weight-bold">
            Submission Details
          </v-card-title>

          <v-divider />

          <v-card-text v-if="submission">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>User ID</v-list-item-title>
                  <v-list-item-subtitle>{{
                    submission.userId
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Submission ID</v-list-item-title>
                  <v-list-item-subtitle>{{
                    submission._id
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Created At</v-list-item-title>
                  <v-list-item-subtitle>{{
                    formatDate(submission.createdAt)
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Rewarded</v-list-item-title>
                  <v-chip
                    small
                    dark
                    :color="submission.isRewarded ? 'green' : 'orange'"
                  >
                    {{ submission.isRewarded ? "Yes" : "No" }}
                  </v-chip>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Duplicate</v-list-item-title>
                  <v-chip
                    small
                    dark
                    :color="submission.isDuplicate ? 'red' : 'green'"
                  >
                    {{ submission.isDuplicate ? "Duplicate" : "Unique" }}
                  </v-chip>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Location</v-list-item-title>
                  <v-list-item-subtitle>
                    <p>
                      📍 {{ submission.location.lat }},
                      {{ submission.location.lng }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-divider />

          <!-- Actions -->
          <!-- <v-card-actions>
            <v-spacer />
            <v-btn color="red" dark @click="confirmReject">
              Reject Submission
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>

    <!-- Reject Dialog -->
    <v-dialog v-model="rejectDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Reject submission?</v-card-title>
        <v-card-text>
          This action cannot be undone. The submission will be marked as
          rejected.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="rejectDialog = false">Cancel</v-btn>
          <v-btn color="red" dark @click="rejectSubmission">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2.js";
const service = new RestResource();

export default {
  data() {
    return {
      submission: null,
      rejectDialog: false,
    };
  },

  mounted() {
    this.fetchSubmission();
  },

  methods: {
    async fetchSubmission() {
      this.$setLoader();
      try {
        const id = this.$route.params.submissionId;
        const response = await service.getOuternetSubmission({
          submissionId: id,
        });

        const raw = response.data?.data?.[0];
        if (!raw) return;

        this.submission = {
          id: raw._id,
          userId: raw.userId,
          imageUrl: raw.imageUrl,
          location: {
            lat: raw.location.coordinates[1],
            lng: raw.location.coordinates[0],
            isDuplicate: raw.location.isDuplicate,
          },
          isRewarded: raw.isRewarded,
          createdAt: raw.createdAt,
          updatedAt: raw.updatedAt,
        };
      } finally {
        this.$disableLoader();
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    confirmReject() {
    //   this.rejectDialog = true;
    },
    async rejectSubmission() {
      //   this.$setLoader();
      //   try {
      //     await service.rejectOuternetSubmission(this.submission._id);
      //     this.$router.back();
      //   } finally {
      //     this.$disableLoader();
      //     this.rejectDialog = false;
      //   }
    },
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 12px;
}
</style>
